import { useCreateOpco } from '../../hooks/OpCo';
import useShowError from '../../hooks/useShowError';
import useShowToast from '../../hooks/useShowToast';
import { OperatingCompanyCreate } from '../../api/generated';
import { useQueryClient } from '@tanstack/react-query';
import { ERROR_MESSAGES } from '../../constants/opCoConstants'
import OpCoForm from './OpCoForm';
interface IOpCoFormData {
    opcoConfigurationMode: string,
    slug: string,
    name: string,
    description: string,
    invoiceemailid: string,
    rejectionemailtype: string,
    rejectemailid: string,
    unprocessedemailid: string, //
    transmittingsummaryinfo: string,
    po_feed: string,
    invoice_feed: string,
    supplier_feed: string,
    reconcilliation_feed: string,
    sla_invoiceprocessingdays: string,
    sla_invoiceoverduenotificationdays: string,
    invoiceretention: string,
    dataretention: string,
    worklistname: string,
    teamname: string,
    emailprovider: string,
    erpprovider: string,
    additionalsystems: 'Yes' | 'No' | '',
    additionalsystemsdetails: string
}

export default function OpCoOnboardForm({ onCancelOpco }: { onCancelOpco: () => void }) {
    const initialOpCoFormData: IOpCoFormData = {
        opcoConfigurationMode: 'single',
        name: 'test',
        slug: '',
        description: '',
        invoiceemailid: '',
        rejectionemailtype: '',
        rejectemailid: '',
        po_feed: '',
        supplier_feed: '',
        transmittingsummaryinfo: '',
        invoice_feed: '',
        reconcilliation_feed: '',
        sla_invoiceprocessingdays: '',
        sla_invoiceoverduenotificationdays: '',
        worklistname: '',
        teamname: '',
        unprocessedemailid: '',
        invoiceretention: '',
        dataretention: '',
        emailprovider: '',
        erpprovider: '',
        additionalsystems: 'No',
        additionalsystemsdetails: '',
    };

    const createOpcoForm = useCreateOpco().mutate
    const showError = useShowError()
    const showSuccessToast = useShowToast()
    const queryClient = useQueryClient()
    const handleSubmit = (formData) => {
        createOpcoForm(formData as any, {
            onSuccess: (response) => {
                showSuccessToast("Successfully Created Business Unit")
                queryClient.setQueryData(["opco"], (old: Array<OperatingCompanyCreate>) =>
                    [response, ...old]
                )
                onCancelOpco()
                queryClient.refetchQueries({queryKey:["teams"]})
                queryClient.refetchQueries({queryKey:["validation_config_rules"]})
                queryClient.refetchQueries({queryKey:["validation_rules"]})
            },
            onError: (error: any) => {

                if (error?.code === "ERR_NETWORK") {
                    showError(ERROR_MESSAGES.NETWORK);
                } else if (error) {
                    const status = error?.status
                    const detail = error?.body && error?.body?.detail
                    if (status === 422 && Array.isArray(detail)) {
                        const messages = detail.map((item: any) => {
                            return `${item.msg}`
                        }).join('\n')
                        showError(`${messages}`)
                    } else if (status >= 500) {
                        showError(ERROR_MESSAGES.SERVER_500)
                    } else if (status >= 400 && status <= 500) {
                        if(typeof detail === 'string'){
                            showError(`${detail}`)
                        }else{
                        showError(ERROR_MESSAGES.SERVER_400)
                        }
                    }
                    else {
                        showError(ERROR_MESSAGES.UPDATE_COMPANY_FAILED)
                    }
                } else {
                    showError(`${error?.message || ERROR_MESSAGES.UNKNOWN}.`)
                }
            },
        })

    }
    return (
        <OpCoForm
            mode="create"
            initialData={initialOpCoFormData}
            onSubmit={handleSubmit}
            onCancel={onCancelOpco}
        />
    );
}
